import fs from 'node:fs'
import type {
  AuthoredEntityOrSingleSchema,
  LoadedAuthoredGeneratedSchema
} from '@cli-types/core-engine/add-field.js'
import type { FormSchema } from '@cli-types/core-engine/schema.js'
import { resolveSchemaFilePath } from '@core-engine/schema/schema-reader/resolve-schema-file-path.js'
import { schemaKindFromType } from '@core-engine/schema/schema-reader/schema-kind-from-type.js'
import { parseJsonObject } from './parse-json-object.js'

/**
 * Callers here mutate the raw JSON and write it back, so the slot collapsing
 * and generated-slug injection that `loadSchema` performs must not happen.
 */
export function loadAuthoredGeneratedSchema(
  schemasDir: string,
  name: string
): LoadedAuthoredGeneratedSchema {
  const filePath = resolveSchemaFilePath(schemasDir, name)
  const parsed = parseJsonObject(fs.readFileSync(filePath, 'utf-8'), filePath)
  const kind = schemaKindFromType(name, parsed.type)

  if (kind === 'form') {
    return {
      kind,
      schema: parsed as unknown as FormSchema,
      filePath,
      name
    }
  }

  return {
    kind,
    schema: parsed as unknown as AuthoredEntityOrSingleSchema,
    filePath,
    name
  }
}
